module.exports = __webpack_public_path__ + "static/media/CVR_Bairrada.9aefd89e.svg";